import React from 'react';
import { Grid } from '@mui/material';

import {
  Typography,
  CurrencyInputField,
  TextField,
  ProductGroupSelectField,
  Select,
} from '@occc-app/design-system';
import { Earning_Mechanism_Product_Counting_Attribute } from '@occc/graphql';
import { parseNumber } from '@occc-app/lib/finalFormUtils';
import { ProductPurchaseFormValues } from '@occc-app/offerHelpers/types';

type ProductPurchaseConfigureProps = {
  values?: ProductPurchaseFormValues;
  withCountBySelect?: boolean;
};

const selectData = [
  { label: 'Money Amount', value: Earning_Mechanism_Product_Counting_Attribute.MoneyAmount },
  { label: 'Quantity', value: Earning_Mechanism_Product_Counting_Attribute.Quantity },
  { label: 'Selling Unit', value: Earning_Mechanism_Product_Counting_Attribute.UnitsCount },
];

const ThresholdComponentsInput: React.FC<ProductPurchaseConfigureProps> = ({
  values,
  withCountBySelect,
}) => {
  const isCountByMoneyAmount =
    values?.countProductsBy === Earning_Mechanism_Product_Counting_Attribute.MoneyAmount;
  const thresholdFieldName = 'productPurchase.purchaseThreshold';
  const thresholdFieldLabel = 'Threshold';

  if (withCountBySelect) {
    return (
      <>
        <Grid item sm={2}>
          {isCountByMoneyAmount ? (
            <CurrencyInputField name={thresholdFieldName} label={thresholdFieldLabel} />
          ) : (
            <TextField
              name={thresholdFieldName}
              label={thresholdFieldLabel}
              fieldProps={{
                parse: parseNumber,
              }}
            />
          )}
        </Grid>
        <Grid item sm={3}>
          <Select
            name='productPurchase.countProductsBy'
            label='Count Products By'
            data={selectData}
            formControlProps={{ size: 'medium', margin: 'none' }}
          />
        </Grid>
      </>
    );
  }

  return (
    <Grid item xs={3}>
      <TextField
        name={thresholdFieldName}
        label={thresholdFieldLabel}
        fieldProps={{
          parse: parseNumber,
        }}
      />
    </Grid>
  );
};

export const ProductPurchaseConfigure: React.FC<ProductPurchaseConfigureProps> = ({
  values,
  withCountBySelect,
}) => (
  <>
    <Typography variant='subtitle1' paragraph>
      When They Purchase
    </Typography>
    <Grid container spacing={3}>
      <ThresholdComponentsInput values={values} withCountBySelect={withCountBySelect} />
      <Grid item xs={withCountBySelect ? 7 : 9}>
        <ProductGroupSelectField
          inputProps={{
            margin: 'none',
          }}
          name='productPurchase.eligibleProductGroups'
          label='Product groups'
        />
      </Grid>
    </Grid>
  </>
);
